"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Localize_1 = require("../../../../gen-src/Localize");
exports.FieldNameMappings = {
    Bool: Localize_1.Messages.FieldBool,
    BoolCalc: Localize_1.Messages.FieldBoolCalc,
    DateCalcContinuous: Localize_1.Messages.FieldDateCalcContinuous,
    DateCalcDiscrete: Localize_1.Messages.FieldDateCalcDiscrete,
    DateContinuous: Localize_1.Messages.FieldDateContinuous,
    DateDiscrete: Localize_1.Messages.FieldDateDiscrete,
    DateTimeCalcContinuous: Localize_1.Messages.FieldDateTimeCalcContinuous,
    DateTimeCalcDiscrete: Localize_1.Messages.FieldDateTimeCalcDiscrete,
    DateTimeContinuous: Localize_1.Messages.FieldDateTimeContinuous,
    DateTimeDiscrete: Localize_1.Messages.FieldDateTimeDiscrete,
    GeoCalcContinuous: Localize_1.Messages.FieldGeoCalcContinuous,
    GeoCalcDiscrete: Localize_1.Messages.FieldGeoCalcDiscrete,
    GeoContinuous: Localize_1.Messages.FieldGeoContinuous,
    GeoDiscrete: Localize_1.Messages.FieldGeoDiscrete,
    Group: Localize_1.Messages.FieldGroup,
    GroupGeo: Localize_1.Messages.FieldGroupGeo,
    Hierarchy: Localize_1.Messages.FieldHierarchy,
    NumberCalcContinuous: Localize_1.Messages.FieldNumberCalcContinuous,
    NumberCalcDiscrete: Localize_1.Messages.FieldNumberCalcDiscrete,
    NumberContinuous: Localize_1.Messages.FieldNumberContinuous,
    NumberDiscrete: Localize_1.Messages.FieldNumberDiscrete,
    NumericBinDiscrete: Localize_1.Messages.FieldNumericBinDiscrete,
    NumericBinContinuous: Localize_1.Messages.FieldNumericBinContinuous,
    Set: Localize_1.Messages.FieldSet,
    TextCalcContinuous: Localize_1.Messages.FieldTextCalcContinuous,
    TextCalcDiscrete: Localize_1.Messages.FieldTextCalcDiscrete,
    TextContinuous: Localize_1.Messages.FieldTextContinuous,
    TextDiscrete: Localize_1.Messages.FieldTextDiscrete,
    Unknown: Localize_1.Messages.FieldUnknown
};
//# sourceMappingURL=FieldNameMapping.js.map